import { type Component } from 'solid-js'
import Logo from '../../assets/images/profittree-logo-website.svg'

const SimpleTopBar: Component = () => {
  return (
    <div class="h-[84px] flex w-full px-4 sm:px-10 bg-gunmetal items-center">
      <img src={Logo} alt="ProfitTree" class="h-8"/>
    </div>
  )
}

export default SimpleTopBar
